export const environment = {
  production: false,
  apiUrl: 'http://localhost:5007/api',
  signalRHubUrl: 'http://localhost:5007/chathub',
  reportServerUrl: 'http://localhost:5008/Report_Forms/'
};
